import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { List } from 'immutable';

import { CompanyEmailLogLine } from './CompanyEmailLogLine';

const CompanyEmailPanelComponent = ({ emails, onEditEvent, onMouseEnter, onMouseLeave }) => {
  const content =
    emails.size === 0 ? (
      <p className="text-center"> No rows to display </p>
    ) : (
      emails.map(email => (
        <CompanyEmailLogLine
          key={email.get('eventId')}
          email={email}
          onEditEvent={onEditEvent}
          onMouseEnter={event => onMouseEnter(event, email.get('eventId'))}
          onMouseLeave={event => onMouseLeave(event, email.get('eventId'))}
        />
      ))
    );

  return (
    <div className="panel panel-default">
      <div className="panel-heading" data-parent="#accordion" data-target="#acc-slide-6" data-toggle="collapse">
        <h4 className="panel-title"> Email Log / Buyer Notes </h4>
      </div>
      <div className="panel-collapse collapse" id="acc-slide-6">
        <div className="panel-body">{content}</div>
      </div>
    </div>
  );
};

CompanyEmailPanelComponent.propTypes = {
  emails: PropTypes.instanceOf(List).isRequired,
  onEditEvent: PropTypes.func.isRequired,
  onMouseEnter: PropTypes.func.isRequired,
  onMouseLeave: PropTypes.func.isRequired,
};

/** Company email panel component. */
export const CompanyEmailPanel = memo(CompanyEmailPanelComponent);
